module.exports = __webpack_public_path__ + "static/media/transit.aab372f4.png";